export default __webpack_public_path__ + "total-staff-voilet-icon.svg";